import fetch from "lib/fetch";
import type { CompanyLimitInterface } from "types/collaborator";
import type { UserInterface } from "types/user";
import type { AdInterface } from "types/ad";
import type { ServiceInterface } from "types/service";
import type { ChangePasswordInterface, ChangePasswordResponseInterface } from "types/profile";

interface ListResponse<T> {
    data: Array<T>;
    pager: {
        total: number;
        total_page: number;
        last_page: number;
        per_page: number;
        current_page: number;
        order?: string;
        direction?: string;
        custom?: HashMap<number | undefined>;
    };
    filters: HashMap<unknown>;
}

type UserResponse = { data: UserInterface };
type CompanyLimitResponse = { data: CompanyLimitInterface };
type GenericResponse = { data: unknown };
type FavToggleResponse = { data: { is_favorite: boolean } };
type ChangePasswordResponse = { data: ChangePasswordResponseInterface };

export const getProfileRequest = (id: string) =>
    fetch.get<UserResponse>(`profile/${id}`);

export const updateProfileRequest = (id: string, data: HashMap<unknown>) =>
    fetch.put<UserResponse>(`profile/${id}`, data);

export const updateMyProfileRequest = (id: string, data: HashMap<unknown>) =>
    fetch.put<UserResponse>(`profile/${id}/my_profile`, data);

export const updateProfilePreferencesRequest = (id: string, data: HashMap<unknown>) =>
    fetch.put<UserResponse>(`profile/${id}/preferences`, data);

export const updateProfileCesuRequest = (id: string, data: HashMap<unknown>) =>
    fetch.put<UserResponse>(`profile/${id}/cesu`, data);

export const updateProfileImageRequest = (id: string, data: HashMap<unknown>) =>
    fetch.put<UserResponse>(`profile/${id}/image`, data);

export const changePasswordRequest = (data: ChangePasswordInterface) =>
    fetch.put<ChangePasswordResponse>("profile/password", data);

export const getProfileCompanyLimitRequest = () =>
    fetch.get<CompanyLimitResponse>("profile/company_limit_use");

export type DataleonSession = {
    url: string;
    expires_at?: string | null;
};

export const getDataleonSessionRequest = () =>
    fetch.get<{ data: DataleonSession }>("profile/dataleon/session");

export type CreateStripeAccountPayload = {
    stripe_account_token: string;
    account_name: string;
    iban: string;
};

export type CreateStripeAccountResponse = {
    stripe_id: string;
};

export const createStripeAccountRequest = (data: CreateStripeAccountPayload) =>
    fetch.post<{ data: CreateStripeAccountResponse }>("profile/stripe/account", data);

export const getMyInformationsRequest = () =>
    fetch.post<GenericResponse>("profile/get_my_informations");

export const deleteMyAccountRequest = () =>
    fetch.post<GenericResponse>("profile/delete_my_account");

export const toggleFavRequest = (id: string) =>
    fetch.get<FavToggleResponse>(`profile/ad/${id}/fav`);

export const getFavoritesRequest = () =>
    fetch.get<ListResponse<AdInterface>>("profile/ad/favs");

export const toggleProviderFavRequest = (id: string) =>
    fetch.get<FavToggleResponse>(`profile/provider/${id}/fav`);

export const getProviderFavoritesRequest = () =>
    fetch.get<ListResponse<ServiceInterface>>("profile/provider/favs");
